import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";
import { useKitchenAuth } from "../context/KitchenAuthContext";
import { setStorefront, storefrontUser } from "../utils/storefront";

/**
 * eduw.in/<slug>: a restaurant's public ordering link. Finds the restaurant
 * and drops the customer into the ordering flow — no login.
 */
const Storefront: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const { setUser } = useKitchenAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    if (!slug) return;
    api
      .get(`/public/restaurants/${encodeURIComponent(slug)}`)
      .then((res) => {
        const r = res.data?.data;
        const storefront = { restaurantId: r.restaurantId, slug: r.slug, hotelName: r.hotelName };
        setStorefront(storefront);
        setUser(storefrontUser(storefront));
        navigate("/choice", { replace: true });
      })
      .catch((err) => {
        setError(err.response?.data?.error || "Couldn't open this restaurant");
      });
  }, [slug, navigate, setUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4 text-center">
      {error ? (
        <>
          <h1 className="m-0 text-2xl font-bold text-gray-900">{error}</h1>
          <p className="mt-2 text-gray-500">Please check the link and try again.</p>
        </>
      ) : (
        <p className="text-gray-500">Loading menu…</p>
      )}
    </div>
  );
};

export default Storefront;
